import { formatNumber } from "shared/locale/format";

const AXIS_TEXT_COLOR = "#6F6F6F";

interface AboveBarValueLabelProps {
  value: number;
  cx?: number;
  cy?: number;
}

// Rendered as a ReferenceDot `shape`; recharts supplies cx/cy in pixels.
const AboveBarValueLabel = ({ value, cx, cy }: AboveBarValueLabelProps) => {
  if (cx === undefined || cy === undefined) return null;

  return (
    <text
      x={cx}
      y={cy - 5}
      fill={AXIS_TEXT_COLOR}
      textAnchor="middle"
      fontSize={14}
      data-testid="above-bar-value-label"
    >
      {formatNumber(value, 0)}
    </text>
  );
};

export default AboveBarValueLabel;
